/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SupportIcon extends BaseIcon {
  getChildren = () => [ <path
    d="M13.8,13.8a7.5,7.5,0,1,1,0-10.6A7.49,7.49,0,0,1,13.8,13.8ZM12,14.14,14.15,12l-1.61-1.61a4.32,4.32,0,0,1-.86,1.24,4.63,4.63,0,0,1-1.26.88ZM5,14.14l1.61-1.61a4.63,4.63,0,0,1-1.26-.88,4.32,4.32,0,0,1-.86-1.24L2.85,12ZM5,2.84,2.85,5l1.6,1.6A4.31,4.31,0,0,1,5.32,5.3a4.4,4.4,0,0,1,1.25-.87ZM6,6A3.49,3.49,0,1,0,11,6,3.48,3.48,0,0,0,6,6Zm6-3.19-1.6,1.59a4.4,4.4,0,0,1,1.25.87,4.31,4.31,0,0,1,.87,1.26L14.15,5Z"
    fill={ this.getColor() }/> ]
  getViewBox = () => '0 0 16 16'
}
